import {useSelector} from 'react-redux';
import startCase from 'lodash/startCase';
import {Typography} from '~library/atoms/Typography';
import {Link} from '~library/atoms/Link';
import {Button} from '~library/atoms/Button';
import {
  selectRegistries,
  selectRegistryName,
  selectRegistryNote,
  selectRegistryType,
  selectRegistryWording,
} from '~/common/fabric/reducers/registry/selectors';
import {Header} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/components/Header/Header';
import {Registry, RegistryVendor} from '~/ViewInvitation/common/RegistryVendor';
import {Step} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/Step';

import './RegistryWishlist.sass';

type RegistryWishlistProps = {
  onCloseClick: () => void;
};

export const RegistryWishlist = ({onCloseClick}: RegistryWishlistProps) => {
  const wording = useSelector(selectRegistryWording);
  const registries: Registry[] = useSelector(selectRegistries);
  const registryName = useSelector(selectRegistryName);
  const registryType = useSelector(selectRegistryType);
  const registryNote = useSelector(selectRegistryNote);

  return (
    <Step
      header={
        <Header onClose={onCloseClick} title={`Get a gift from ${registryName}'s ${wording}`} />
      }
      description={`${registryName} has shared a ${wording} — start browsing now to find the perfect gift.`}
      contentClassName="rsvp__registy-wishlist"
      footer={
        <>
          <Link
            as="primary"
            data-impression-tracking="true"
            data-qa-id="af-rsvp-registry-btn"
            href={registries[0].url}
            target="_blank"
          >
            {`View ${startCase(wording)}`}
          </Link>
          <Button
            variant="secondary"
            size="large"
            data-qa-id="af-rsvp-registry-skip"
            onClick={onCloseClick}
            className="rsvp-step__footer__cta"
          >
            Maybe later
          </Button>
        </>
      }
    >
      <div className="registry-wishlist__vendors-and-note">
        <RegistryVendor
          type={registryType}
          registry={registries[0]}
          dataQaId="af-rsvp-registry-card"
          key={`${registries[0].id ?? registries[0].name}`}
        />

        {registryNote && (
          <Typography color="pebble" variant="paragraph3" classNames="registry-wishlist__note">
            &rdquo;{registryNote}&rdquo;
          </Typography>
        )}
      </div>
    </Step>
  );
};
